import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3.js";
import {
  shouldMock,
  getSavedPaymentMethodsMockResponse,
  createUpdateSavedPaymentMethodResponse,
} from "./mockData";

const API = {
  createPaymentMethod: (postData) =>
    shouldMock
      ? callMockResponse({})
      : new FnrFetch3(`/give/createPaymentMethod`, postData),

  replacePaymentMethod: (postData) =>
    new FnrFetch3(`/give/replaceSavedPaymentMethod`, postData),

  getSavedPaymentMethods: (userID = null) =>
    shouldMock
      ? callMockResponse(getSavedPaymentMethodsMockResponse)
      : new FnrFetch3(`/give/getSavedPaymentMethods`, { userID }),

  updateSavedPaymentMethod: (postData) =>
    shouldMock
      ? callMockResponse(createUpdateSavedPaymentMethodResponse(postData))
      : new FnrFetch3(`/give/updateSavedPaymentMethod`, postData),
};

export default API;
